export enum MultiSelectionActionTypes {
  INITIALIZE = 'multi-selection/INITIALIZE',
  DESTROYED = 'multi-selection/DESTROYED',
  ITEM_TOGGLED = 'multi-selection/ITEM_TOGGLED',
  ALL_ITEMS_TOGGLED = 'multi-selection/ALL_ITEMS_TOGGLED',
  ITEMS_SELECTED = 'multi-selection/ITEMS_SELECTED',
}
